import {
    updateOWAConnectedAccountToken,
    updateOWAConnectedAccountStatus,
} from 'owa-accounts-store';
import { ConnectedAccountResponse, getAccessToken } from 'owa-link-account';

export default async function getAndUpdateRefreshToken(
    accountId: string,
    primarySmtpAddress: string
): Promise<string> {
    const response = (await getAccessToken(accountId)) as ConnectedAccountResponse; // to do: handle error scenario/error response

    if (response && response.token && response.userAccount) {
        updateOWAConnectedAccountToken(
            response.userAccount.emailAddress,
            response.token.accessToken,
            response.token.expiresIn
        );
        updateOWAConnectedAccountStatus(primarySmtpAddress, parseInt(response.token.expiresIn) > 0);
        return response.token.accessToken;
    } else {
        updateOWAConnectedAccountStatus(primarySmtpAddress, false);
        return undefined;
    }
}
